// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".desc[data-v-557e3936]{height:40px;line-height:40px;font-weight:700;font-size:16px}.item[data-v-557e3936]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center;font-size:14px}.item[data-v-557e3936]:last-child{margin-bottom:0}", ""]);
// Exports
module.exports = exports;
